import React from "react";
import YTPlayer from "../youtubePlayer/YTPlayer";
import TV from '../../assets/images/TV.jpg';
import Counter from '../counter/counter';

const About = (p) => {
  const store = p.store;
  const toggleClass = (e, className) => {
    e.target.classList.contains(className) ? 
      e.target.classList.remove(className) : 
      e.target.classList.add(className);
  }
  const opts = {
    width: '640',
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 0,
    },
  };
  return (
    <div className="page-content grid about-grid">
      <div className="about_author block1">
      <figure>
          <img src={TV} alt="Tatjana Viktorovna Auderskaja" />
        <figcaption>
          Verkisto, tradukanto, biologo. Gvidanto de Odesa junulara Esperanto-klubo "Verdaĵo".
        </figcaption>
      </figure>
      <Counter store={store}></Counter>
      </div>
      <div className="p-3 block2">
        <p>
          Tatjana Auderskaja havas publikaĵojn beletrajn (tradukojn el rusa poezio, originalan fantaston, parodiojn) 
          kaj priesperantajn artikolojn en papera kaj reta formo, 
          inkluzive artikolojn en la rusa lingvo en la prestiĝa rusa revuo "Scienco kaj Vivo" 
          ("Nauka i Ĵizn", № 1 - 2005) kaj esperantlingvajn en Beletra Almanako №№ 20, 22 kaj 26. 
        </p>
        <p>
          Ŝi estas aŭtoro de la tekstoj de du prinaturaj videofilmoj en Esperanto: 
          <i>"La sovaĝa vivo de sudaj kanejoj"</i> kaj <i>"La perloj de Ĉenigramarujo"</i>, 
          kaj ankaŭ de la ruslingva filmo <i>“Esperanto” signifas “Tiu, kiu esperas”</i>, 
          kreitaj de la esperanto-klubo "Verdaĵo" kunlabore kun profesia filmisto.
        </p>
        <p>
          Skriptis kaj partoprenis en la filmo pri Esperanto kaj L. Zamenhof, filmita en la Odesa Ŝtata Televidstudio en 2009, al la 150-a datreveno de L. Zamenhof.
        </p>
      </div>
      <div className="p-3 block3">
        <button className="accordion" onClick={(e)=>toggleClass(e, 'active')}>
          Rigardi la filmon <i>"La sovaĝa vivo de sudaj kanejoj"</i>
          <span className="accordion-arrow"></span>
        </button>
        <div className="panel">
          <div className="auto-resizable-iframe">
            <YTPlayer videoid="jCB2jSwEc9g" opts={opts}></YTPlayer>
          </div>
        </div>

        <button className="accordion" onClick={(e)=>toggleClass(e, 'active')}>
          Rigardi la filmon <i>"La perloj de Ĉenigramarujo"</i>
          <span className="accordion-arrow"></span>
        </button>
        <div className="panel">
          <div className="auto-resizable-iframe">
            <YTPlayer videoid="CHuBMoNhE1E" opts={opts}></YTPlayer>
          </div>
        </div>

        <button className="accordion" onClick={(e)=>toggleClass(e, 'active')}>
          Rigardi la filmon pri Zamengof
          <span className="accordion-arrow"></span>
        </button>
        <div className="panel">
          <div className="auto-resizable-iframe">
            <YTPlayer videoid="md11986GICk" opts={opts}></YTPlayer>
          </div>
        </div>
          
        <p>
          En 2008 publikigis tradukon de scienc-populariga libro de Ju. N. Sokolov 
          <i>"Ekologio de homo el sistema vidpunkto"</i>, AVE, 2008. 
          Partoprenis en tradukado kaj reviziado de la libro de Noam Chomsky 
          <i>"Imperiaj ambicioj"</i>, UEA, 2013. 
          En 2017 publikigis tradukon de <i>"Duonfabeloj (Mikrofabloj)"</i> 
          de Feliks Krivin en <i>"Beletra Almanako"</i> № 29.
        </p>
        <p>
          Tatjana Auderskaja havas du eldonitajn librojn en Esperanto:
        </p>
        <ul>
          <li>
            <p>
              <i>"La mondo en guto da akvo: ilustrita rakonto pri malgrandaj estaĵoj"</i>. 
              Moskvo: Impeto, 2010. 104 p. ISBN: 9785716102132. <br/>
              En 2016 ĝi ricevis la premion Pirlot por la plej bona scienca libro de 2010-2016.
            </p>
          </li>
          <li>
            <p>
              <i>"Intelektaj amuzoj. Lingvaj ludoj en Esperanto"</i>. 
              Novjorko: Mondial, 2016. 113 p. ISBN: 9781595693228.
            </p>
          </li>
        </ul>
        <p>
          En 2018 iniciatis, kompilis kaj multe kontribuis al la ruslingva almanako 
          <i>"La plej bonaj tagoj de nia vivo. Pri la lingvo Esperanto kaj ne nur"</i> 
          ("Лучшие дни нашей жизни. О языке эсперанто и не только"), 
          Ridero, 2018, 120 p. ISBN 978-5-4493-1399-7
        </p>
        <p>
          En 2018 komencis krei retan 6-lingvan <a href="http://vortaro.zzz.com.ua/" target="_blank" rel="noreferrer">
            Biologian vortaron</a>: 
          rusa - latina - Esperanta - angla - germana- hispana
        </p>
        <p>
          Ekde 2019 ano de la Akademio de Esperanto
        </p>
      </div>
    </div>
  )
}

export default About;